import {
    LICENCE_CATEGORY,
    OTHER_DETAILS,
    STATION,
    BASED_LAND_FIXED_STATION_INFORMATION,
    STATION_ADDRESS,
    LATITUDE,
    LONGITUDE,
    VENDOR_INFORMATION,
    VENDOR_ADDRESS,
    RADIO_EQUIPMENT_INFORMATION,
    ANTENNA_INFORMATION,
    ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
    FILTER_INFORMATION,
    FEEDER_INFORMATION,
    FREQUENCY_AND_EMISSION_CLASS_INFORMATION,
    SUPPORTING_DOCUMENTS
} from '../../../../common/application.const/Licence/MyApplication/FWNApplication';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatFWNApplication = async (
    licenceDetails: any,
    caseTypeID: string,
    application?: string,
    totalNoOfStations?: string,
    transactionType?: any
) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfoList = [];
    let stationList = [];

    newDocs = [];

    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfoList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => ({
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-call-sign`]: value?.callSign ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-station-name`]: value?.stationName ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-location-of-station`]: value?.locationOfStationEGRooftop ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-date-of-comissioning`]: value?.DateofCommissioning ?? '-',

            [`${STATION_ADDRESS}-building-name`]: value?.stationAddress?.buildingName ?? '-',
            [`${STATION_ADDRESS}-postal-code`]: value?.stationAddress?.postalCode ?? '-',
            [`${STATION_ADDRESS}-street-name`]: value?.stationAddress?.streetName ?? '-',
            [`${STATION_ADDRESS}-block-house-no`]: value?.stationAddress?.blockNo ?? '-',
            [`${STATION_ADDRESS}-unit`]: value?.stationAddress?.unit ?? '-',
            [`${STATION_ADDRESS}-floor-level`]: value?.stationAddress?.floor ?? '-',

            [`${LATITUDE}-latitude-degrees`]: value?.LatitudeDegreesDesc ?? '-',
            [`${LATITUDE}-latitude-minutes`]: value?.latitudeMinutes ?? '-',
            [`${LATITUDE}-latitude-seconds`]: value?.latitudeSeconds ?? '-',

            [`${LONGITUDE}-longitude-degrees`]: value?.longitudeDegrees ?? '-',
            [`${LONGITUDE}-longitude-minutes`]: value?.longitudeMinutes ?? '-',
            [`${LONGITUDE}-longitude-seconds`]: value?.longitudeSeconds ?? '-',

            [`${LONGITUDE}-building-height`]: value?.buildingHeightM ?? '-',
            [`${LONGITUDE}-station-antenna-effective-height`]: value?.stationAntennaEffectiveHeightMAboveGroundLevel ?? '-',
            [`${LONGITUDE}-transportable`]: value?.transportable ?? '-',
            [`${LONGITUDE}-station-antenna-elevation-angle`]:
                value?.stationAntennaElevationAngleWithReferenceToHorizontalPlaneDegree ?? '-',
            [`${LONGITUDE}-radius-of-operation`]: value?.radiusOfOperationKm ?? '-',

            [`${VENDOR_INFORMATION}-vendor-name`]: value?.vendorName ?? '-',
            [`${VENDOR_INFORMATION}-vendor-licence-number`]: value?.vendorLicenceNumber ?? '-',
            [`${VENDOR_INFORMATION}-contact-person`]: value?.contactPerson ?? '-',
            [`${VENDOR_INFORMATION}-contact-number`]: value?.ContactNumber ?? '-',

            [`${VENDOR_ADDRESS}-building-name`]: value?.vendorAddress?.buildingName ?? '-',
            [`${VENDOR_ADDRESS}-postal-code`]: value?.vendorAddress?.postalCode ?? '-',
            [`${VENDOR_ADDRESS}-street-name`]: value?.vendorAddress?.streetName ?? '-',
            [`${VENDOR_ADDRESS}-block-house-no`]: value?.vendorAddress?.blockNo ?? '-',
            [`${VENDOR_ADDRESS}-unit`]: value?.vendorAddress?.unit ?? '-',
            [`${VENDOR_ADDRESS}-floor-level`]: value?.vendorAddress?.floor ?? '-',

            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-transmitter`]: value?.manufacturerTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-receiver`]: value?.manufacturerReceiver ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-transmitter`]: value?.modelTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-receiver`]: value?.modelReceiver ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-output-power`]: value?.outputPowerWTransmitter ?? '-',

            [`${ANTENNA_INFORMATION}-antenna-manufacturer`]: value?.antennaManufacturer ?? '-',
            [`${ANTENNA_INFORMATION}-polarization`]: value?.PolarizationDesc ?? '-',
            [`${ANTENNA_INFORMATION}-if-others-please-specifiy`]: value?.ifOthersPleaseSpecify ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-effective-height`]: value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-elevation-angle`]: value?.antennaElevationAngleWithReferenceToHorizontalPlaneDegree ?? '-',

            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-north-latitude-displacement`]: value?.northLatitudeDisplacement ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-east-longitude-displacement`]: value?.eastLongitudeDisplacement ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-gain-db`]: value?.gainDB ?? '-',

            [`${FILTER_INFORMATION}-filter-manufacturer`]: value?.filterManufacturer ?? '-',
            [`${FILTER_INFORMATION}-model`]: value?.model ?? '-',
            [`${FILTER_INFORMATION}-insertion-loss`]: value?.insertionLossDB ?? '-',
            [`${FILTER_INFORMATION}-tuned-frequency`]: value?.tunedFrequencyMHz ?? '-',

            [`${FEEDER_INFORMATION}-feeder-line-type-transmit`]: value?.feederLineTypeTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-type-receive`]: value?.feederLineTypeReceive ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-transmit`]: value?.feederLineLengthMTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-receive`]: value?.feederLineLengthMReceive ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-transmit`]: value?.feederLineLossDBTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-receive`]: value?.feederLineLossDBReceive ?? '-',

            [`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`]:
                (value?.frequencyAndEmissionClassInformation ?? []).map((i: any, index: number) => {
                    return {
                        sn: i?.rowId,
                        'desired-frequency-mhz-from-tx': i?.desiredFrequencyMHzFromTransmit ?? '-',
                        'desired-frequency-mhz-to-tx': i?.desiredFrequencyMHzToTransmit ?? '-',
                        'desired-frequency-mhz-from-rx': i?.desiredFrequencyMHzFromReceive ?? '-',
                        'desired-frequency-mhz-to-rx': i?.desiredFrequencyMHzToReceive ?? '-',
                        'desired-bandwidth-khz-tx': i?.bandwidthKHzTransmit ?? '-',
                        'desired-bandwidth-khz-rx': i?.bandwidthKHzReceive ?? '-',
                        'start-time': i?.startTime ?? '-',
                        'stop-time': i?.stopTime ?? '-',
                        'emission-class-transmit': i?.emissionClassTransmit ?? '-',
                        'emission-class-receive': i?.emissionClassReceive ?? '-'
                    };
                }) ?? '-'
        }));
    }

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        stationList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => {
            const list = {
                id: index + 1,
                label: value?.stationName
            };

            return list;
        });
    }

    licence = {
        id: 'fixed-wireless-network',
        formID: 'fixed-wireless-network',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

            [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
            [`${OTHER_DETAILS}-remarks-by-applicant`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${STATION}-station-name`]: stationList ?? '-',
            [`${STATION}-total-number-of-stations`]: totalNoOfStations ?? '-',

            [`${BASED_LAND_FIXED_STATION_INFORMATION}-list`]: baseLandFixedStationInfoList ?? [...baseLandFixedStationInfoList],
            [`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`]:
                baseLandFixedStationInfoList[0][`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`] ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-fixed-wireless-network',
            formID: 'amend-fixed-wireless-network',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_CATEGORY}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                [`${LICENCE_CATEGORY}-licence-category`]:
                    licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

                [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
                [`${OTHER_DETAILS}-remarks-by-applicant`]: licenceDetails?.otherDetails?.remarks ?? '-',

                [`${STATION}-station-name`]: stationList ?? '-',
                [`${STATION}-total-number-of-stations`]: totalNoOfStations ?? '-',

                [`${BASED_LAND_FIXED_STATION_INFORMATION}-list`]: baseLandFixedStationInfoList ?? [...baseLandFixedStationInfoList],
                [`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`]:
                    baseLandFixedStationInfoList[0][`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`] ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    return licence;
};

const fwnApplicationPayload = {
    formatFWNApplication
};

export default fwnApplicationPayload;
